import React from "react";
import { Flex } from "@UI/Components/Flex/Flex";
import { Icon } from "@UI/Components/Icon/Icon";
import { Text } from "@UI/Components/Text/Text";
import { BuildingUser } from "@UI/Components/Icons/BuildingUser";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "@modules/ServiceProviders/Components/messages";

export const ProClientBadge = () => {
    return (
        <Flex
            as="span"
            alignItems="center"
            bg="#E6F5FF"
            color="#006AB1"
            borderRadius="5px"
            px="8px"
            py="5px"
            fontSize="xs"
            lineHeight="100%"
            display="inline-flex"
        >
            <Icon as={BuildingUser} mr="3px" />
            <Text as="span" fontSize="inherit" lineHeight="inherit" mb={0}>
                <FormattedMessage {...messages.companyInfoBusinessClientBadge} />
            </Text>
        </Flex>
    );
};
